import { render, staticRenderFns } from "./IconSettings.vue?vue&type=template&id=314c59d6&scoped=true"
import script from "./IconSettings.vue?vue&type=script&lang=js"
export * from "./IconSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314c59d6",
  null
  
)

export default component.exports